/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { StyleSheet } from 'aphrodite';
import { colors, fonts, mixins, variables } from '@blend/consumer-components';

const sectionPadding = mixins.padding(20, 40);

export default StyleSheet.create({
  header: {
    ...sectionPadding,
    ...mixins.borderBottom(1, 'solid', colors.clayMinus2),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },

  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },

  title: {
    fontSize: 18,
    fontWeight: fonts.weight.bold,
    color: colors.clayPlus4,
    marginTop: 10,
  },

  iconWrapper: {
    paddingRight: 10,
  },

  body: {
    position: 'relative',
  },

  mainContent: {
    ...sectionPadding,
    ...fonts.UntitledSans,
    color: colors.clayPlus4,
    fontSize: 15,
    lineHeight: 1.5,
  },

  description: {
    marginBottom: 30,
  },

  addButtonWrapper: mixins.marginVertical(20),

  addButton: {
    ...mixins.marginHorizontal(18),
    fontSize: 14,
    fontWeight: fonts.weight.semibold,
    cursor: 'pointer',
    color: colors.neutralBlue,

    ':hover': {
      color: mixins.darken(colors.neutralBlue, 0.15),
    },
  },

  addAnotherText: {
    marginLeft: 8,
  },

  uploadList: {
    padding: 0,
    margin: 0,
    fontSize: 14,
    listStyle: 'none',
  },

  uploadItem: mixins.marginVertical(10),

  submitProgress: {
    height: 4,
    width: '100%',
    // Sticky so that it doesn't pull down the body container
    position: 'absolute',
    bottom: 0,
  },

  footer: {
    ...sectionPadding,
    ...mixins.bottomRadius(variables.globalBorderRadius),
    display: 'flex',
    backgroundColor: colors.snowPlus1,
  },

  primaryButton: mixins.flexPullRight(),

  secondaryButton: mixins.flexPullLeft(),
});
